/**
 * 组件信息
 */
export const info = {
  name: 'xy-input', // 组件名
  type: 'component-base', // 组件类型
  label: '输入框', // 组件label
  icon: 'icon-xy-text', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 100 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  modelValue: String,
  label: String,
  type: {
    type: String,
    default: 'text'
  },
  placeholder: String,
  maxlength: {
    type: Number,
    default: 20
  },
  minlength: {
    type: Number,
    default: 0
  },
  required: Boolean,
  validate: Function,
  asyncValidate: Function,
  clearable: Boolean,
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: {},
      // 事件
      events: []
    })
  },
  textAlign: {
    type: String,
    default: 'left'
  },
  autofocus: {
    type: Boolean,
    default: true
  },
  onlyNumber: {
    type: Boolean,
    default: false
  }
}

/**
 * 组件开放方法事件
 */
export const events = [
  {
    name: 'setValue',
    label: '设置值',
    params: [{ label: '值', value: 'value' }]
  }
]

/**
 * 组件开放数据源
 */
export const dataSource = [
  {
    label: '文本',
    keys: 'value'
  }
]

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input-number', // 表单组件
    label: '最大字数', // 表单名称
    propKey: 'maxlength' // 表单model字段名称
  },
  {
    type: 'xy-form-input-number', // 表单组件
    label: '最小字数', // 表单名称
    propKey: 'minlength' // 表单model字段名称
  },
  {
    type: 'xy-form-input', // 表单组件
    label: '占位文本', // 表单名称
    propKey: 'placeholder', // 表单model字段名称
    isLanguage: true // 是否可多语言配置
  },
  {
    type: 'xy-form-switch', // 表单组件
    label: '自动聚焦', // 表单名称
    propKey: 'autofocus' // 表单model字段名称
  },
  {
    type: 'xy-form-switch', // 表单组件
    label: '是否只输入数字', // 表单名称
    propKey: 'onlyNumber' // 表单model字段名称
  },
  {
    type: 'xy-form-select', // 表单组件
    label: '输入方向', // 表单名称
    propKey: 'textAlign', // 表单model字段名称
    isLanguage: true, // 是否可多语言配置
    options: [
      {
        label: '从左往右',
        value: 'left'
      },
      {
        label: '从右往左',
        value: 'right'
      }
    ]
  }
]
